import { render, staticRenderFns } from "./LanguagesForm.vue?vue&type=template&id=66f8863e&scoped=true"
import script from "./LanguagesForm.vue?vue&type=script&lang=ts"
export * from "./LanguagesForm.vue?vue&type=script&lang=ts"
import style0 from "./LanguagesForm.vue?vue&type=style&index=0&id=66f8863e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f8863e",
  null
  
)

export default component.exports